import CouponList from '@/views/coupon/coupon-list.vue';
import CouponDetail from '@/views/coupon/coupon-detail.vue';
import CouponMemberList from '@/views/coupon/coupon-member-list.vue';

export default [
    {
        path: '/coupon/coupon-member-list',
        component: CouponMemberList,
        name: 'couponMemberList'
    },
    {
        path: '/coupon/coupon-list',
        component: CouponList,
        name: 'couponList'
    },
    {
        path: '/coupon/coupon-detail',
        component: CouponDetail,
        name: 'couponDetail'
    },
]